import styled from 'styled-components';

export const Notice = styled.div<{ $warning?: boolean }>`
  font-size: 12px;
  margin-bottom: 16px;
  color: ${({ theme, $warning }) =>
    $warning ? theme.colors.danger.danger : theme.colors.surface.onSurfaceVariant};
`;

export const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  margin-bottom: 9px;
`;

export const SpeCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  padding: 14px 17px;
  margin-bottom: 12px;
`;

export const SpeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 12px;

  strong {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }
`;

export const Share = styled.span`
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const Tag = styled.span`
  display: inline-block;
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary.primary};
`;

// Três blocos lado a lado (fiscal, endereço, representante) que empilham em
// telas estreitas.
export const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const Block = styled.dl`
  margin: 0;

  dt {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    margin-top: 6px;
  }

  dd {
    margin: 0;
    font-size: 13px;
    overflow-wrap: anywhere;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }
`;

export const DetailsSection = styled.div`
  margin-top: 22px;
`;
